import { io } from 'socket.io-client';

let socket = null;

export const connect = (token) => {
  if (socket && socket.connected) return socket;

  const url = process.env.NODE_ENV === 'production' ? '/' : 'http://localhost:5000';

  socket = io(url, { transports: ['websocket'] });

  socket.on('connect', () => {
    socket.emit('authenticate', token);
  });

  return socket;
};

export const disconnect = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const on = (event, cb) => {
  if (socket) socket.on(event, cb);
};

export const off = (event, cb) => {
  if (socket) socket.off(event, cb);
};
